// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from PopupArrow.module.scss  */
.PopupArrow-module-Root_KxM {
  position: absolute; }

.PopupArrow-module-Path_16A {
  filter: drop-shadow(-1px 0 0 var(--popup-border-color-default, #ececec));
  stroke-width: 0; }

[data-popper-placement^='right'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {
  left: -7px;
  width: 7px;
  height: 24px; }

[data-popper-placement^='left'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {
  right: -7px;
  width: 7px;
  height: 24px; }

[data-popper-placement^='right'] .PopupArrow-module-Svg_18l,
[data-popper-placement^='left'] .PopupArrow-module-Svg_18l {
  width: 7px;
  height: 24px; }

[data-popper-placement^='left'] .PopupArrow-module-Svg_18l {
  transform: rotate(180deg); }

[data-popper-placement^='bottom'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {
  top: -7px;
  width: 24px;
  height: 24px; }

[data-popper-placement^='bottom'] .PopupArrow-module-Svg_18l {
  transform: rotate(90deg); }

[data-popper-placement^='top'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {
  bottom: -7px;
  width: 24px;
  height: 24px; }

[data-popper-placement^='top'] .PopupArrow-module-Svg_18l {
  transform: rotate(-90deg); }

[data-popper-placement^='top'] .PopupArrow-module-Svg_18l,
[data-popper-placement^='bottom'] .PopupArrow-module-Svg_18l {
  width: 24px;
  height: 24px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Popup/Arrow/PopupArrow.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,kBAAkB,EAAE;;AAEtB;EACE,wEAAwE;EACxE,eAAe,EAAE;;AAEnB;EACE,UAAU;EACV,UAAU;EACV,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,UAAU;EACV,YAAY,EAAE;;AAEhB;;EAEE,UAAU;EACV,YAAY,EAAE;;AAEhB;EACE,yBAAyB,EAAE;;AAE7B;EACE,SAAS;EACT,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,wBAAwB,EAAE;;AAE5B;EACE,YAAY;EACZ,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,WAAW;EACX,YAAY,EAAE","sourcesContent":["/*  imported from PopupArrow.module.scss  */\n.PopupArrow-module-Root_KxM {\n  position: absolute; }\n\n.PopupArrow-module-Path_16A {\n  filter: drop-shadow(-1px 0 0 var(--popup-border-color-default, #ececec));\n  stroke-width: 0; }\n\n[data-popper-placement^='right'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {\n  left: -7px;\n  width: 7px;\n  height: 24px; }\n\n[data-popper-placement^='left'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {\n  right: -7px;\n  width: 7px;\n  height: 24px; }\n\n[data-popper-placement^='right'] .PopupArrow-module-Svg_18l,\n[data-popper-placement^='left'] .PopupArrow-module-Svg_18l {\n  width: 7px;\n  height: 24px; }\n\n[data-popper-placement^='left'] .PopupArrow-module-Svg_18l {\n  transform: rotate(180deg); }\n\n[data-popper-placement^='bottom'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {\n  top: -7px;\n  width: 24px;\n  height: 24px; }\n\n[data-popper-placement^='bottom'] .PopupArrow-module-Svg_18l {\n  transform: rotate(90deg); }\n\n[data-popper-placement^='top'] > .PopupArrow-module-Root_KxM[data-popper-arrow] {\n  bottom: -7px;\n  width: 24px;\n  height: 24px; }\n\n[data-popper-placement^='top'] .PopupArrow-module-Svg_18l {\n  transform: rotate(-90deg); }\n\n[data-popper-placement^='top'] .PopupArrow-module-Svg_18l,\n[data-popper-placement^='bottom'] .PopupArrow-module-Svg_18l {\n  width: 24px;\n  height: 24px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
